module.exports = __webpack_public_path__ + "img/13.ce0c5317.png";